import React from 'react';
import { Box, Typography } from '@mui/material';

const Logo = ({ size = 'medium', showTagline = false, variant = 'default' }) => {
  const getSizeStyles = () => {
    switch (size) {
      case 'small':
        return {
          height: 24
        };
      case 'large':
        return {
          height: 48
        };
      default: // medium
        return {
          height: 32
        };
    }
  };

  const { height } = getSizeStyles();

  const getTextStyles = () => {
    switch (size) {
      case 'small':
        return {
          fontSize: '1rem',
          gap: 0.5
        };
      case 'large':
        return {
          fontSize: '2rem',
          gap: 1
        };
      default: // medium
        return {
          fontSize: '1.5rem',
          gap: 0.8
        };
    }
  };

  const { fontSize, gap } = getTextStyles();

  return (
    <svg
      width={height * 0.6}
      height={height}
      viewBox="0 0 30 54"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Simple brick pattern */}
      <rect x="0" y="0" width="30" height="18" fill="#1976D2" rx="2"/>
      <rect x="15" y="18" width="30" height="18" fill="#0D47A1" rx="2"/>
      <rect x="0" y="36" width="30" height="18" fill="#1976D2" rx="2"/>
    </svg>
  );
};

export default Logo;